import { isBrandInNAM } from "@faire/help-center-self-serve/utils/isBrandInNAM";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalAccountRoute from "@faire/web-api--source/routes/brand-portal/account";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var UpdatePayoutsIA = function UpdatePayoutsIA(_ref) {
  var brand = _ref.brand;
  if (isBrandInNAM(brand)) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "gbEM9B",
      defaultMessage: "You can choose when you want to get paid after orders ship. Payouts are initiated based on the payout option selected, but may take 3-5 business days to reflect in your account, depending on your bank\u2019s processing time. Your payment processing fee is based on your selection."
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "CYGSaU",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: "<BoldFormatting>Next day payout</BoldFormatting>: 3.5% + $0.30",
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "zaIu+A",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: "<BoldFormatting>30-day payout</BoldFormatting>: 2.4% + $0.30",
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "bZnAZH",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: "<BoldFormatting>60-day payout</BoldFormatting>: 1.9% + $0.30",
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "q1sTS9",
      defaultMessage: "To change your payout option, and corresponding payment processing fee, go to <AccountSettingLinkFormatting>Account settings</AccountSettingLinkFormatting> and select the <PayoutLinkFormatting>Payout</PayoutLinkFormatting> tab.",
      values: {
        AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "my-account");
        },
        PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "payment");
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "oGyzWH",
      defaultMessage: "Changes will apply to all future orders placed after the payout setting is updated. Contact us to change your payout option on existing orders."
    })));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "iMNCJo",
    defaultMessage: "You can choose when you want to get paid after orders ship. Payouts are initiated based on the payout option selected, but may take 3-5 business days to reflect in your account, depending on your bank\u2019s processing time. Your payment processing fee is based on your selection."
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3kOCho",
    defaultMessage: "<BoldFormatting>ACH Next Day</BoldFormatting>: 3% payout fee is applied to both the order and shipping costs",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ljpEqK",
    defaultMessage: "<BoldFormatting>ACH 30-day</BoldFormatting>: no payout fee ",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "S45UJf",
    defaultMessage: "To change your payout option, and corresponding payment processing fee, go to <AccountSettingLinkFormatting>Account settings</AccountSettingLinkFormatting> and select the <PayoutLinkFormatting>Payout</PayoutLinkFormatting> tab.",
    values: {
      AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "my-account");
      },
      PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JR23KI",
    defaultMessage: "Changes will apply to all future orders placed after the payout setting is updated. Contact us to change your payout option on existing orders."
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};